<template>
	<div @click="newSpeciesLogSearch(species)">
		<figure>
			<q-img :src="species.teaser" :alt="species.name" ratio="1" basic/>
			<figcaption>{{ species.name }}</figcaption>
		</figure>
	</div>
</template>

<script>
	import LogSearchMixin from "@/mixins/LogSearchMixin";

	export default {
		name: "SpeciesTeaser",
		props: ['species'],
		mixins: [LogSearchMixin],
	}
</script>

<style lang="scss" scoped>
	div {
		position: relative;
		cursor: pointer;
	}

	figure {
		position: relative;
		overflow: hidden;
		margin: 0;

		img {
			vertical-align: bottom;
			width: 100%;
		}

		figcaption {
			position: absolute;
			left: 0;
			bottom: 0;
			padding: 15px 5px 15px 5px;
			width: 100%;
			color: #fff;
			text-shadow: rgba(0, 0, 0, 0.8) 1px 1px 2px;
		}
	}

	@media(min-width: 600px) {
		figure {
			figcaption {
				text-shadow: none;
				padding: 30px 0 15px 15px;
				background: rgba(0, 0, 0, 0.4);
				background: linear-gradient(180deg, transparent 0%, #000 143%);
				background: -moz-linear-gradient(top, transparent 0%, #000 143%);
				background: -webkit-linear-gradient(top, transparent 0%, #000 143%);
				background: -o-linear-gradient(top, transparent 0%, #000 143%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
			}
		}
	}
</style>